import { h, Fragment } from '@stencil/core';
import { EEvent, comparator } from '@pes-ui/utils';
import { getMyProductsFromConnector } from '../pes-my-products-connector/utils';
import { DEFAULT_CATEGORY_PRODUCT_CTAS } from '../category-subcategory-listing/constants';
import { isMobile } from '../../globals/utils';
import { parseRichText } from '../../globals/utils/helpers';
export class PesCategorySubcategoryProductsList {
  constructor() {
    this.handleComparatorChange = (e) => {
      this.comparatorValue = e.detail;
    };
    this.handleProductCtasChange = (event) => {
      if (!this.productCtas)
        return;
      if (this.isPBS) {
        this.productCtas = Object.assign({}, this.productCtas);
        return;
      }
      this.productCtas = Object.assign(Object.assign({}, this.productCtas), { buttons: event.detail });
    };
    this.hostWithLocale = undefined;
    this.navigationState = undefined;
    this.pills = undefined;
    this.showDocuments = undefined;
    this.showBuyOnline = undefined;
    this.enableCommerceConnector = undefined;
    this.productCtas = DEFAULT_CATEGORY_PRODUCT_CTAS;
    this.parentPage = '';
    this.isMobileCategorySelected = undefined;
    this.isMobileView = undefined;
    this.numberProductsOfAllProductsLabel = undefined;
    this.appProductsLabel = undefined;
    this.loadMoreLabel = undefined;
    this.loadPreviousLabel = undefined;
    this.previousLabel = undefined;
    this.nextLabel = undefined;
    this.labelValue = undefined;
    this.productsCountLabel = undefined;
    this.productsSectionTitleLabel = undefined;
    this.noResultsClearLinkLabel = undefined;
    this.noResultsHeaderLabel = undefined;
    this.noResultsMessageLabel = undefined;
    this.isProductsLoading = false;
    this.parsedProducts = null;
    this.selectedPage = undefined;
    this.productsPerPage = undefined;
    this.localeCode = undefined;
    this.showCompare = true;
    this.storageName = undefined;
    this.isPBS = false;
    this.currentPageStorageKey = undefined;
    this.enableAppRouting = false;
    this.analyticsPageData = undefined;
    this.comparatorValue = comparator.value;
    this.productsIds = [];
    this.richText = undefined;
    this.scrollToProduct = undefined;
    this.productsCount = 0;
    this.resultsCount = undefined;
    this.lastLoadedRecNum = undefined;
    this.firstLoadedRecNum = undefined;
    this.el.dir = (document === null || document === void 0 ? void 0 : document.documentElement.dir) || 'auto';
  }
  componentWillLoad() {
    this.setProductsInfo(this.parsedProducts);
  }
  connectedCallback() {
    window === null || window === void 0 ? void 0 : window.addEventListener(EEvent.COMPARATOR_PRODUCTS_CHANGE, this.handleComparatorChange);
  }
  disconnectedCallback() {
    window === null || window === void 0 ? void 0 : window.removeEventListener(EEvent.COMPARATOR_PRODUCTS_CHANGE, this.handleComparatorChange);
  }
  onParsedProductsChange(newProducts) {
    this.setProductsInfo(newProducts);
  }
  setScrollToProduct(event) {
    this.scrollToProduct = event.detail;
  }
  setProductsInfo(productsInfo) {
    if (!productsInfo)
      return;
    const { totalNumRecs, firstRecNum, recsPerPage, productIds, richText } = productsInfo;
    const productsCount = productIds.length;
    this.richText = parseRichText(richText);
    const lastRecNum = firstRecNum + productsCount - 1;
    this.productsCount = productsInfo.totalNumRecs;
    this.resultsCount = {
      firstRecNum,
      lastRecNum,
      recsPerPage,
      totalNumRecs,
    };
    if (!isMobile()) {
      this.firstLoadedRecNum = undefined;
      this.lastLoadedRecNum = undefined;
      this.productsIds = [];
    }
    this.firstLoadedRecNum = this.firstLoadedRecNum === undefined
      ? firstRecNum
      : Math.min(firstRecNum, this.firstLoadedRecNum);
    this.lastLoadedRecNum = this.lastLoadedRecNum === undefined
      ? lastRecNum
      : Math.max(lastRecNum, this.lastLoadedRecNum);
    this.productsIds = productIds;
  }
  getAdditionalMainQueryParams() {
    return { nodeOrSubCatId: this.navigationState, isCategoryListing: true };
  }
  renderProductCards() {
    var _a, _b, _c;
    if (this.isProductsLoading || this.productsIds.length) {
      return (h("product-cards-wrapper", { class: "products-list__list", currentPageStorageKey: this.currentPageStorageKey, showDocuments: this.showDocuments, showBuyOnline: this.showBuyOnline, showCompare: this.showCompare, comparator: this.comparatorValue, enableCommerceConnector: this.enableCommerceConnector, "product-ids": this.productsIds.join(), host: this.hostWithLocale, hostWithLocale: this.storageName, additionalMainQueryParams: this.getAdditionalMainQueryParams(), productCtas: this.productCtas, productOfProductsLabel: this.numberProductsOfAllProductsLabel, productsLabel: this.appProductsLabel, firstRecNum: (_a = this.resultsCount) === null || _a === void 0 ? void 0 : _a.firstRecNum, lastRecNum: (_b = this.resultsCount) === null || _b === void 0 ? void 0 : _b.lastRecNum, totalNumRecs: (_c = this.resultsCount) === null || _c === void 0 ? void 0 : _c.totalNumRecs, areListGridLabelsShown: false, scrollToProduct: this.scrollToProduct, enableAppRouting: this.enableAppRouting, localeCode: this.localeCode, isProductListing: true, analyticsPageData: this.analyticsPageData, parentPage: this.parentPage }, this.productsSectionTitleLabel && (h("div", { slot: "title" }, h("h3", { class: "products-list__title" }, this.productsSectionTitleLabel, h("span", { class: "products-list__count" }, " (", this.productsCount, ") ")))), h("div", { slot: "pills" }, h("pes-range-filter-pills", { pills: this.pills }))));
    }
  }
  renderNoResults() {
    return (h(Fragment, null, h("pes-range-filter-pills", { pills: this.pills }), h("pes-filters-no-results", { noResultsClearLink: this.noResultsClearLinkLabel, noResultsHeader: this.noResultsHeaderLabel, noResultsMessage: this.noResultsMessageLabel })));
  }
  render() {
    var _a, _b;
    if (!this.isProductsLoading && !this.productsIds.length && !((_a = this.richText) === null || _a === void 0 ? void 0 : _a.length)) {
      return this.renderNoResults();
    }
    return (h(Fragment, null, h("pes-range-product-ctas-updater", { buttons: (_b = this.productCtas) === null || _b === void 0 ? void 0 : _b.buttons, myProductsGetter: getMyProductsFromConnector, onButtonsChange: this.handleProductCtasChange }), h("pes-products-pagination", { firstLoadedRecNum: this.firstLoadedRecNum, lastLoadedRecNum: this.lastLoadedRecNum, totalNumRecs: this.productsCount, productsPerPage: this.productsPerPage, showMobilePagination: this.isMobileView && this.isMobileCategorySelected, showDesktopPagination: !this.isMobileView, selectedPage: this.selectedPage, loadMoreLabel: this.loadMoreLabel, loadPreviousLabel: this.loadPreviousLabel, previousLabel: this.previousLabel, nextLabel: this.nextLabel, labelValue: this.labelValue, productsCountLabel: this.productsCountLabel }, this.richText && h("pes-rich-text-information", { richText: this.richText }), this.renderProductCards())));
  }
  static get is() { return "pes-category-subcategory-products-list"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-category-subcategory-products-list.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-category-subcategory-products-list.css"]
    };
  }
  static get properties() {
    return {
      "hostWithLocale": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "host-with-locale",
        "reflect": false
      },
      "navigationState": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "navigation-state",
        "reflect": false
      },
      "pills": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TProductsPillsData[]",
          "resolved": "TProductsPillsData[]",
          "references": {
            "TProductsPillsData": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "showDocuments": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-documents",
        "reflect": false
      },
      "showBuyOnline": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-buy-online",
        "reflect": false
      },
      "enableCommerceConnector": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "enable-commerce-connector",
        "reflect": false
      },
      "productCtas": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TProductCtas",
          "resolved": "{ buttons: TProductCtasButtons; productProp?: string; }",
          "references": {
            "TProductCtas": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "defaultValue": "DEFAULT_CATEGORY_PRODUCT_CTAS"
      },
      "parentPage": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "PesPageType",
          "resolved": "\"\" | \"all-products\" | \"category\" | \"comparator\" | \"product\" | \"product-cart\" | \"range\" | \"subcategory\"",
          "references": {
            "PesPageType": {
              "location": "import",
              "path": "../../globals/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "parent-page",
        "reflect": false,
        "defaultValue": "''"
      },
      "isMobileCategorySelected": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-mobile-category-selected",
        "reflect": false
      },
      "isMobileView": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-mobile-view",
        "reflect": false
      },
      "numberProductsOfAllProductsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "number-products-of-all-products-label",
        "reflect": false
      },
      "appProductsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "app-products-label",
        "reflect": false
      },
      "loadMoreLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "load-more-label",
        "reflect": false
      },
      "loadPreviousLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "load-previous-label",
        "reflect": false
      },
      "previousLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "previous-label",
        "reflect": false
      },
      "nextLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "next-label",
        "reflect": false
      },
      "labelValue": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "label-value",
        "reflect": false
      },
      "productsCountLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "products-count-label",
        "reflect": false
      },
      "productsSectionTitleLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "products-section-title-label",
        "reflect": false
      },
      "noResultsClearLinkLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "no-results-clear-link-label",
        "reflect": false
      },
      "noResultsHeaderLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "no-results-header-label",
        "reflect": false
      },
      "noResultsMessageLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "no-results-message-label",
        "reflect": false
      },
      "isProductsLoading": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-products-loading",
        "reflect": false,
        "defaultValue": "false"
      },
      "parsedProducts": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "SprykerParsedProductsResponse",
          "resolved": "{ richText?: string[]; firstRecNum: number; lastRecNum: number; recsPerPage: number; totalNumRecs: number; productIds?: string[]; }",
          "references": {
            "SprykerParsedProductsResponse": {
              "location": "import",
              "path": "../../globals/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "defaultValue": "null"
      },
      "selectedPage": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "selected-page",
        "reflect": false
      },
      "productsPerPage": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "products-per-page",
        "reflect": false
      },
      "localeCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "locale-code",
        "reflect": false
      },
      "showCompare": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-compare",
        "reflect": false,
        "defaultValue": "true"
      },
      "storageName": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "storageName in indexDB for saving breadcrumbs"
        },
        "attribute": "storage-name",
        "reflect": false
      },
      "isPBS": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether the component is integrated to PBS."
        },
        "attribute": "is-p-b-s",
        "reflect": false,
        "defaultValue": "false"
      },
      "currentPageStorageKey": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "SUBCATEGORY/4200"
            }],
          "text": "key for getting breadcrumbs from the indexDB"
        },
        "attribute": "current-page-storage-key",
        "reflect": false
      },
      "enableAppRouting": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "enable-app-routing",
        "reflect": false,
        "defaultValue": "false"
      },
      "analyticsPageData": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "MetaTags['analyticsPageData']",
          "resolved": "{ articleTitle: string | number; businessUnit: string; pageRangeId: string; pageSubCategoryId: string; pageCategoryId: string; pageSubCategory: string; pageProductId: string; fromWebView: boolean; digitalPlatform: string; digitalPlatformCountry: string; pageLanguage: string; environment: string; template: string; pageSubSubCategory: string; pageTopCategory: string; pageCategory: string; pageTitle: string; }",
          "references": {
            "MetaTags": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
  static get states() {
    return {
      "comparatorValue": {},
      "productsIds": {},
      "richText": {},
      "scrollToProduct": {},
      "productsCount": {},
      "resultsCount": {},
      "lastLoadedRecNum": {},
      "firstLoadedRecNum": {}
    };
  }
  static get elementRef() { return "el"; }
  static get watchers() {
    return [{
        "propName": "parsedProducts",
        "methodName": "onParsedProductsChange"
      }];
  }
  static get listeners() {
    return [{
        "name": "scrollToProduct",
        "method": "setScrollToProduct",
        "target": undefined,
        "capture": false,
        "passive": false
      }];
  }
}
